export const opsViewSourceId = 'ops-view-source';

export const opsViewTrackingCircleAndHeadingLineSourceId = `${opsViewSourceId}_tracking_circle_and_heading_line`;
export const opsViewAircraftSourceId = 'ops-view-source_aircraft';
export const opsViewUsersSourceId = `ops_view_users_source`;
export const opsViewAircraftLayerId = 'ops-view-aircraft_icon_layer';
export const opsViewUsersCircleLayerId = 'ops-view-users_circle_layer';

//Types of objects in opsView
//userStream - phone
//userOnly - phone
//aircraftStream - aircraft
//aircraftOnly - aircraft
//streamOnly - video icon

export const aircraftIconExpression = [
	'case',
	['==', ['get', 'is_sim'], true],
	'simulator_icon',
	[
		'match',
		['get', 'aircraft_type'],
		'uav',
		'drone_icon',
		'aircraft',
		'drone_icon',
		'adsb',
		[
			'match',
			['get', 'adsb_emitter_type'],
			'single_engine',
			'single_engine_airplane_icon',
			'jet',
			'jet_airplane_icon',
			'large',
			'large_airplane_icon',
			'helicopter',
			'helicopter_icon',
			'airplane_icon'
		],
		'asterix',
		'chevron_icon',
		'adsl',
		'chevron_icon',
		'rid',
		'drone_icon',
		'sensor',
		'radar_icon',
		'airplane_icon'
	]
];

export const aircraftOutlineIconExpression = [
	'case',
	['==', ['get', 'is_sim'], true],
	'simulator_outline_icon',
	[
		'match',
		['get', 'aircraft_type'],
		'uav',
		'drone_outline_icon',
		'aircraft',
		'drone_outline_icon',
		'adsb',
		[
			'match',
			['get', 'adsb_emitter_type'],
			'single_engine',
			'single_engine_airplane_outline_icon',
			'jet',
			'jet_airplane_outline_icon',
			'large',
			'large_airplane_outline_icon',
			'helicopter',
			'helicopter_outline_icon',
			'airplane_outline_icon'
		],
		'asterix',
		'chevron_outline_icon',
		'adsl',
		'chevron_outline_icon',
		'rid',
		'drone_outline_icon',
		'sensor',
		'radar_outline_icon',
		'airplane_outline_icon'
	]
];

export const aircraftDoubleOutlineIconExpression = [
	'case',
	['==', ['get', 'is_sim'], true],
	'simulator_double_outline_icon',
	[
		'match',
		['get', 'aircraft_type'],
		'uav',
		'drone_double_outline_icon',
		'aircraft',
		'drone_double_outline_icon',
		'adsb',
		[
			'match',
			['get', 'adsb_emitter_type'],
			'single_engine',
			'single_engine_airplane_double_outline_icon',
			'jet',
			'jet_airplane_double_outline_icon',
			'large',
			'large_airplane_double_outline_icon',
			'helicopter',
			'helicopter_double_outline_icon',
			'airplane_double_outline_icon'
		],
		'asterix',
		'chevron_double_outline_icon',
		'adsl',
		'chevron_double_outline_icon',
		'rid',
		'drone_double_outline_icon',
		'sensor',
		'radar_double_outline_icon',
		'airplane_double_outline_icon'
	]
];

// export const trackingLayerTextLayerLayout = {
// 	'text-field': [
// 		'case',
// 		['==', ['get', 'label_type'], 'heading'],
// 		['get', 'heading'],
// 		['==', ['get', 'label_type'], 'agl'],
// 		['concat', ['to-string', ['get', 'altitude_agl_ft']], ' ft AGL'],
// 		'' // fallback
// 	],
// 	'text-size': ['interpolate', ['linear'], ['zoom'], 8, 8, 15, 30],
// 	'text-anchor': 'center',
// 	'text-allow-overlap': true,
// 	'text-padding': 5
// };

export const opsViewUsersCluserCircleLayerId = 'ops_view_users_cluster_circle_layer';
export const opsViewUsersClusterCountLayerId = 'ops_view_users_cluster_count_layer';
export const opsViewClusterLayers = [
	opsViewUsersCluserCircleLayerId,
	opsViewUsersClusterCountLayerId
];
